module Meevo.Plugins.SaleProgram {
    "use strict";

    import ISaleProgram = Meevo.Model.ISaleProgram;

    export class ProductsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<ISaleProgram> {
        model: ISaleProgram;

        private productsList: any[];
        private discountAmount: number;
        private discountPercent: number;

        private isShowDiscontinued: boolean = false;
        private productCategories: any[];
        private manufacturers: any[];
        private distributors: any[];
        private subCategoryId: string = null;
        private displayName: string = null;
        private manufacturerId: string = null;
        private distributorId: string = null;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            private $sce: ng.ISCEService,
            securityKey?: string) {

            super(
                sectionId, 
                displayNameContentKey, 
                template, 
                isPrimarySection, 
                handlesOwnCrud, 
                baseEndpoint, 
                sectionEndpoint, 
                loggingService, 
                dataService, 
                identityService, 
                noun,
                null,
                securityKey);

            this.setInitialValues();
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint)
                .then((data: ISaleProgram) => {
                    this.model = data;
                });
        }

        loadProductsList(model: ISaleProgram): void {
            let data = {
                id: model.id,
                businessTypeId: model.businessTypeId,
                startDate: model.startDate,
                endDate: model.endDate,
            };

            this.dataService.customMethodData(`api/saleProgram/${model.id}/product/list`, 'POST', data)
                .then((response: any) => {
                    this.productsList = _(response.data).filter(item => !item.notForSale);

                    this.generateFilters();
                });
        }

        private generateFilters() {
            this.isShowDiscontinued = false;
            this.subCategoryId = null;
            this.displayName = null;
            this.manufacturerId = null;
            this.distributorId = null;

            this.productCategories = _.chain(this.productsList)
                .map(item => ({
                    id: item.subCategoryId,
                    displayName: `${item.category}: ${item.subCategory}`,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();

            this.manufacturers = _.chain(this.productsList)
                .map(item => ({
                    id: item.manufacturerId,
                    displayName: item.manufacturer,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();

            this.distributors = _.chain(this.productsList)
                .map(item => item.distributors)
                .flatten()
                .map(item => ({
                    id: item.distributorId,
                    displayName: item.distributor,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();
        }

        setInitialValues(): void {
        }

        preSave(): void {
        }

        sectionModelRetrieved(): void {
            if (!this.model) return;

            this.loadProductsList(this.model);

            switch (this.model.products.discountTypeEnum) {
                case Meevo.Model.DiscountTypeEnum.AmountOff:
                case Meevo.Model.DiscountTypeEnum.SpecialPrice:
                    this.discountAmount = this.model.products.discountAmount;
                    break;
                case Meevo.Model.DiscountTypeEnum.PercentOff:
                    this.discountPercent = this.model.products.discountAmount;
                    break;
            }
        }

        displayItem(item: any): string {
            const sku = (item.sku ? `${item.sku}: ` : '');
            const variantDisplayName = (item.variantDisplayName ? `: ${item.variantDisplayName}` : '');

            return (item.isDiscontinued ? this.$sce.trustAsHtml('\u2731') : '') 
                + sku 
                + item.productDisplayName 
                + variantDisplayName;
        }

        discountAmountChanged() {
            this.model.products.discountAmount = this.discountAmount;
        }

        discountPercentChanged() {
            this.model.products.discountAmount = this.discountPercent;
        }

        filter(item: any): boolean {
            if (!this.isShowDiscontinued && item.isDiscontinued) {
                return false;
            }

            if (this.subCategoryId && item.subCategoryId !== this.subCategoryId) {
                return false;
            }

            if (this.displayName && this.displayName.length > 2) {
                let productDisplayName = item.productDisplayName || '';
                let variantDisplayName = item.variantDisplayName || '';

                if (!(productDisplayName.toLowerCase().indexOf(this.displayName.toLowerCase()) > -1 ||
                    variantDisplayName.toLowerCase().indexOf(this.displayName.toLowerCase()) > -1)) {
                    return false;
                }
            }

            if (this.manufacturerId && item.manufacturerId !== this.manufacturerId) {
                return false;
            }

            if (this.distributorId && _(item.distributors).all(distributor => distributor.distributorId !== this.distributorId)) {
                return false;
            }

            return true;
        }

        filterModal() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/saleProgram/modal/products.filter.template.html",
                controller: "meevo.plugins.saleProgram.ProductsFilterController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    context: this,
                }
            }

            this.modalService.showCustom(options);
        }
    }
}